import { InputSwitchTogether } from 'react-together-primereact'

export function PrimeReactInputSwitchTogetherDemo() {
  return (
    <div className='flex-col place-items-center'>
      <InputSwitchTogether rtKey='input-switch-doc-demo' />
    </div>
  )
}
